// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1d2bba0a","571":"555a34da","876":"de30b3ae"}[chunkId] + ".chunk.js";
};